angular.module('v3sWbtPlayerApp').directive('v3sPopupCarousel', ["$rootScope",  function ($rootScope) {
    return {
        restrict: "E",
        scope: {
            v3sPopups: "=",
            v3sClose : "&"
        },
        templateUrl : "app/js/page/popup/v3sPopupCarousel.tpl.html",
        link: function (scope, element, attrs) {
            var slides = null;
            var dragging = false;
            var onShowHandler;
            scope.activeslide = 0;
            var direction = "next";

            function showHandler() {
                slides = angular.element(element[0].querySelectorAll(".v3s-slide"));
                slides.addClass('with-transition');
            }

            onShowHandler = $rootScope.$on('carousel.show', showHandler);
            scope.$on("$destroy", onShowHandler);

            scope.prev = function () {
                if (scope.activeslide == 0) return;
                scope.activeslide--;
                scope.jumpTo(scope.activeslide);
            }

            scope.next = function () {
                if (scope.activeslide + 1 == slides.length) return;
                scope.activeslide++;
                scope.jumpTo(scope.activeslide);
            }

            scope.jumpTo = function(pos){
                scope.$evalAsync(function () {
                    scope.activeslide = pos;
                })
                calculateTransform(pos);
                dragging = false;
            }


            scope.hidePopup = function (evt) {
                evt.stopPropagation();
                evt.preventDefault();
                scope.v3sClose();
            }

            function calculateTransform(pos) {
                var transform;
                var ngSlide;
                angular.forEach(slides, function (slide, index) {
                    ngSlide = angular.element(slide);
                    if (index == scope.activeslide) {
                        ngSlide.addClass("activeSlide");
                    } else {
                        ngSlide.removeClass("activeSlide");
                    }
                    transform = (100*index) - (100*pos)
                    ngSlide.css({
                        "transform" : "translateX("+ transform +"%)",
                        "-ms-transform" : "translateX("+ transform +"%)"
                    })
                })
            }
        }
    }

}]);